"use client"

import type React from "react"

interface WaveDisplayProps {
  wave: number
  totalWaves: number
  score: number
  className?: string
  style?: React.CSSProperties
}

export const WaveDisplay = ({ wave, totalWaves, score, className, style }: WaveDisplayProps) => {
  return (
    <div
      id="wave-display"
      className={
        className || "bg-black bg-opacity-60 text-white pl-4 pr-2 py-1 rounded-lg flex items-center justify-between gap-1.5 relative min-w-25"
      }
      style={style}
    >
      <div className="absolute -left-1.5 top-1/2 -translate-y-1/2">
        <img
          src="/images/icon-waves.png"
          alt="Score"
          width={28}
          height={28}
          className="drop-shadow-lg"
          style={{ imageRendering: "pixelated" }}
        />
      </div>
      <span className="font-bold text-white text-sm ml-2 pl-1.5">
        {score}
      </span>
      <span className="text-white/70 text-xs">
        {wave}/{totalWaves}
      </span>
    </div>
  )
}
